
export interface OrbType {
  radius: number;
  color: string; // Center/Highlight
  glowColor: string; // Outer glow/Shadow
  rimColor: string; // Edge definition
  score: number;
  name: string;
}

// "Cyber-Zen" Palette: Deep, rich, neon-adjacent colors
export const ORB_TYPES: OrbType[] = [
  { radius: 15, color: '#f8fafc', glowColor: '#e2e8f0', rimColor: '#ffffff', score: 2, name: 'Dust' },             // White
  { radius: 22, color: '#00d2ff', glowColor: '#0072ff', rimColor: '#e0f7ff', score: 4, name: 'Comet' },            // Bioluminescent Blue (Enhanced)
  { radius: 30, color: '#4ade80', glowColor: '#22c55e', rimColor: '#86efac', score: 8, name: 'Planetoid' },        // Green
  { radius: 40, color: '#fbbf24', glowColor: '#f59e0b', rimColor: '#fcd34d', score: 16, name: 'Moon' },            // Amber
  { radius: 52, color: '#f87171', glowColor: '#ef4444', rimColor: '#fca5a5', score: 32, name: 'Dwarf Star' },      // Red
  { radius: 65, color: '#c084fc', glowColor: '#a855f7', rimColor: '#d8b4fe', score: 64, name: 'Pulsar' },          // Purple
  { radius: 80, color: '#22d3ee', glowColor: '#06b6d4', rimColor: '#67e8f9', score: 128, name: 'Ice Giant' },      // Cyan
  { radius: 95, color: '#fb923c', glowColor: '#f97316', rimColor: '#fdba74', score: 256, name: 'Gas Giant' },      // Orange
  { radius: 115, color: '#e879f9', glowColor: '#d946ef', rimColor: '#f0abfc', score: 512, name: 'Nebula' },        // Fuchsia
  { radius: 140, color: '#94a3b8', glowColor: '#64748b', rimColor: '#cbd5e1', score: 1024, name: 'Supernova' },    // Silver
  { radius: 170, color: '#facc15', glowColor: '#eab308', rimColor: '#fef08a', score: 2048, name: 'Black Hole' },   // Gold
];

export const SPECIALS = {
  DEBRIS: { id: 100, radius: 28, color: '#334155', glowColor: '#1e293b', name: 'Space Debris' }, // Dark Slate
  ANTIMATTER: { id: 101, radius: 18, color: '#ffffff', glowColor: '#00ffff', name: 'Antimatter' } // White/Cyan Glitch
};

export const PHYSICS_CONFIG = {
  GRAVITY_Y: 1.4, // Base Gravity
  RESTITUTION: 0.35, 
  FRICTION: 0.005,
  GAME_WIDTH: 400,
  GAME_HEIGHT: 600,
  ASPECT_RATIO: 400 / 600,
  BLAST_RADIUS: 110, // Reduced from 220 for skill-based clearing
  CHAIN_REACTION_MULTIPLIER: 1.5, // Blast is bigger if it hits debris
  SPAM_WINDOW: 750, // Time in ms between clicks considered "spamming"
  MAX_SPAM_STREAK: 5, // Lenient threshold
  OVERHEAT_DURATION: 3000, // Lockout time when overheated
};

// Arcade Progression
export const LEVEL_THRESHOLDS = [
  0,      // Level 1
  1500,   // Level 2 (Slightly harder)
  4000,   // Level 3
  8000,   // Level 4
  15000,  // Level 5
  30000,  // Level 6
  50000,  // Level 7
  75000,  // Level 8
  100000, // Level 9
  150000  // Level 10
];

export const SOUND_FREQUENCIES = [
  261.63, 329.63, 392.00, 493.88, 523.25, 659.25, 783.99, 987.77, 1046.50
];

export const STORAGE_KEYS = {
  HIGH_SCORE: 'nebula-merge-highscore-v4', 
  GAME_STATE: 'nebula-merge-gamestate-v4',
  TUTORIAL_SEEN: 'nebula-merge-tutorial-seen-v1',
};
